<template>
  <section class="blog-list">
    <!-- <div class="col-md-4" v-for="(item,index) in 6" :key="index" v-if="!mags.length">
        <content-loader :height="290" :speed="2" :animate="true"></content-loader>
    </div>-->
    <div class="card flex-column mb-4 box-shadow h-md-250">
      <div class="box-img">
        <span class="image" :style="{ backgroundImage: `url('${image}')`}"></span>
        <!-- <progressive-img class="card-img-top" :src="appUrl.media +'/'+ img" /> -->
      </div>

      <div class="card-body d-flex flex-column align-items-start">
        <strong class="d-inline-block mb-2 text-primary rtl text-right title">{{title}}</strong>
        <h3 class="my-1">
          <a :href="'/user/'+userId" class="text-dark fullname" >{{fullname}}</a>
        </h3>
        <div class="mb-1 text-muted d-flex align-items-center justify-content-center">
          <i class="flaticon-calendar icon-18 ml-1"></i>
          <span class="font-14">{{pub_date | date}}</span>
        </div>
        <!-- <p class="rtl text-right card-text mb-auto">ی مقاله خوب ی مقاله خوب ی مقاله خوب ی مقاله خوب ی مقاله خوب </p> -->
        <a
          :href="'http://blog.madya.ir/'+id+'/'+removeSpace(title)"
          class="font-14 d-inline-block bttn-fill bttn bttn-primary mt-2"
          v-ripple
        >
          <!-- <i class=" mdi mdi-clock-start"></i> -->
          جزییات بیشتر
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "blog-list",
  props: {
    userId: {
      type: Number,
      default: ""
    },
    img: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    fullname: {
      type: String,
      default: ""
    },
    pub_date: {
      type: String,
      default: ""
    },
    id: {
      type: Number,
      default: ""
    }
  },
  computed: {
    image() {
      return this.appUrl.media + "/" + this.img;
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.getPosts();
  },
  methods: {
    removeSpace(str){
      return str.replace(/\s+/g, '-')
    },
    async getPosts() {
      try {
        let { data } = await axios.post("/blog/get-posts", { page_num: 1 });
        if (data.state != 200) return;
        // this.mags = data.posts
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.blog-list {
  .box-clear;
  .title {
    height: 20px;
    font-size: 12px;
  }
  .fullname {
    font-size: 16px;
    display: block;
  }
  .box-img {
    // height: 200px;
    overflow: hidden;
    padding-bottom: 77.55%;
    position: relative;
    .image {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      border-radius: inherit;
      background-position: 50%;
      background-size: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blog/list.vue